// #339: validate user/content-supplied links before navigating or opening a
// window. Content links come from the dbServer content store and are rendered
// into window.location / window.open; a javascript: or data: URL there is a
// stored-XSS / phishing vector. Only allow absolute http(s) (and protocol-
// relative, which resolve to the page's https) destinations.

export function isSafeHttpUrl(value) {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  // Protocol-relative ("//host/path") resolves to the current page protocol
  // (https in production), so it is safe.
  if (trimmed.startsWith("//")) return true;
  let parsed;
  try {
    // Resolve against the current origin so relative paths are accepted and the
    // scheme of any absolute URL is normalised for the allowlist check.
    parsed = new URL(trimmed, window.location.origin);
  } catch (err) {
    return false;
  }
  return parsed.protocol === "http:" || parsed.protocol === "https:";
}
